'use client';

import * as Styled from './styled';
import { ModalWrapperProps } from 'react-hooks-use-modal';
import * as Icon from '@/ui/Icon';

type TModal = React.FC<ModalWrapperProps<Record<string, unknown>>>;

export const OxenModal = ({
  Modal,
  close,
  isOpen,
  children,
  style,
}: {
  Modal: TModal;
  close?: () => void;
  isOpen: boolean;
  children: React.ReactNode;
  style?: React.CSSProperties;
}) => {
  return isOpen ? (
    <Modal>
      <Styled.Modal style={style}>
        {close && (
          <Styled.CloseButtonFixed onClick={close}>
            <Icon.X height={12} width={12} style={{ strokeWidth: 2 }} />
          </Styled.CloseButtonFixed>
        )}
        {children}
      </Styled.Modal>
    </Modal>
  ) : null;
};

const CloseButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <Styled.CloseButton onClick={onClick}>
      <Icon.X height={12} width={12} style={{ strokeWidth: 2 }} />
    </Styled.CloseButton>
  );
};

export default Object.assign(OxenModal, {
  Header: Styled.Header,
  Body: Styled.Body,
  Footer: Styled.Footer,
  CloseButton,
});
